import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import TeamIllustrationSrc from "images/team-illustration-2.svg";
import {ReactComponent as SvgDotPattern } from "images/dot-pattern.svg";

const Container = tw.div`relative items-center pb-40 -mx-8`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto pt-16 md:pt-16`;
const Column = tw.div`pb-8 w-full mx-auto md:mx-auto md:mx-auto`;
const ImageColumn = tw(Column)`md:w-6/12 flex-shrink-0 relative`;
const Paragraph = tw.p`my-2 lg:my-2 text-sm lg:text-base font-medium text-gray-700 max-w-lg mx-auto lg:mx-0`;
const TextColumn = styled(Column)(props => [
  tw`md:w-6/12 mt-2 md:mt-0`,
  props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`
]);

const Image = styled.img(props => [
  props.imageRounded && tw``,
  props.imageBorder && tw`border`,
  props.imageShadow && tw`shadow`,
]);

const DecoratorBlob = styled(SvgDotPattern)(props => [
  tw`w-4 h-4 absolute right-0 bottom-0 transform translate-x-1/2 translate-y-1/2 fill-current text-primary-500 -z-10`,
])

const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(
  SectionHeading
)`text-gray-800 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-gray-100`;

const PrimaryButton = styled(PrimaryButtonBase)(props => [
  tw`tracking-wider bg-[#fc0606] text-gray-100 rounded-full mt-4 md:mt-4 text-sm inline-block mx-auto md:mx-0 hocus:bg-gray-900 hocus:text-[#fc0606]`,
  props.buttonRounded && tw`rounded-full`
]);


export default ({
  subheading = "",
  heading = (
    <>
      {/* Designed & Developed by <span tw="text-primary-500">Professionals.</span> */}
    </>
  ),
  description = "",
  primaryButtonText = "",
  primaryButtonUrl = "",
  primaryLink = "",
  imageSrc = TeamIllustrationSrc,
  buttonRounded = true,
  imageRounded = true,
  imageBorder = true,
  imageShadow = false,
  imageCss = null,
  imageDecoratorBlob = false,
  imageDecoratorBlobCss = null,
  textOnLeft = true
}) => {
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.

  return (
    <Container>
      <TwoColumn>
        <ImageColumn>
          <Image css={imageCss} src={imageSrc} imageBorder={imageBorder} imageShadow={imageShadow} imageRounded={imageRounded}/>
          {/* {imageDecoratorBlob && <DecoratorBlob css={imageDecoratorBlobCss} />} */}
        </ImageColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            <Subheading>{subheading}</Subheading>
            <Heading>{heading}</Heading>
            <Paragraph>{description}</Paragraph>
            {/* <PrimaryLink style={{background: "#29D42D", display: 'block', margin: 'auto', width: 9 + 'rem', borderRadius: 25 +'px', textAlign: 'center', whiteSpace: "nowrap"}} href={matchPath}>Zamów </PrimaryLink> */}
            {/* <PrimaryButton buttonRounded={buttonRounded} as="a" href={primaryButtonUrl}>
              {primaryButtonText}
            </PrimaryButton> */}
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
